<template>
    <div id="edocgrid">
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
                isDelete: true
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>
<script>
import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: this.$t('workflowrole.workflowrole'),
            dataHeader: [
                { text: this.$t('columns.actions'), value: 'action', sortable: false, width:'50px' },
                { text: this.$t('columns.role'), value: 'role', width: '200px' },
                { text: this.$t('roleassignment.description'), value: 'roledesc', width: '200px' },
                { text: this.$t('columns.disable'), value: 'isdisable', width: '100px' },
                { text: this.$t('columns.remark'), value: 'remarks', width: '100px' },
                { text: this.$t('workflowrole.systemrole'), value: 'systemrole', width: '120px' },
                { text: 'Supervisory', value: 'issupervisory', width: '120px' },
            ],
            dataItems: [],
            loading: false,
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        getWorkflowRoleListHandler() {
            const vm = this;

            this.loading = !this.loading;

            this.$store.dispatch('get', {url: `/workflowrole/all/`})
                .then(function (res) {
                    vm.dataItems = res.data.rec;

                    for (let i = 0; i < vm.dataItems.length; i++) {

                        (vm.dataItems[i].systemrole == 0) ? vm.dataItems[i].systemrole = 'No' : vm.dataItems[i].systemrole = 'Yes';
                        (vm.dataItems[i].isdisable == 0) ? vm.dataItems[i].isdisable = 'No' : vm.dataItems[i].isdisable = 'Yes';
                        (vm.dataItems[i].issupervisory == 0) ? vm.dataItems[i].issupervisory = 'No' : vm.dataItems[i].issupervisory = 'Yes';

                    }
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });

        },

        editItemHandler(item) {
            console.log(item);
            this.$router.push({name: 'wfroleedit', params: { id: item.id } });
        },

        deleteItemHandler(item) {
            const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, 'candelete')) {
                return false;
            }

            if (confirm(this.$t('workflowrole.deleteworkflowrole'))) {
                this.$store.dispatch('delete', {
                    url: "/workflowrole/" + item.id + '/' + this.$store.getters.userId
                })
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    window.location.reload();
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            }
        },

        newRecordHandler() {
            this.$router.push({name: 'wfrolenew'});
        }
    },

    mounted() {
        this.getWorkflowRoleListHandler();
    }
}
</script>